// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1wocf","selects":"Documents_selects__3atsv"};